import { getToken, getStatus } from '../../services/aws-marketplace'

export function getAwsMarketplaceToken() {
    return getToken()
}

export function getAwsMarketplaceStatus() {
    return getStatus()
}
